import { api } from '../../../../app/baseQuery';
import { HTTPResponse } from '../../../../common/types/commonTypes';
import { TOUR_PACKAGE_REPORT } from '../../Api/constants';
import { ITourPackageReportFilter, ITourPackageReportList } from '../types/TourPackageTypes';

export const TourPackageEndpoints = api.injectEndpoints({
  endpoints: (build) => ({
    getTourPackageReportList: build.query<
      HTTPResponse<ITourPackageReportList[]>,
      ITourPackageReportFilter
    >({
      query: (params) => ({
        url: `/report/tour-package-report`,
        params,
      }),
      providesTags: [{ type: 'TOUR_PACKAGE_REPORT', id: TOUR_PACKAGE_REPORT }],
    }),
  }),
});

export const { useLazyGetTourPackageReportListQuery } = TourPackageEndpoints;
